import React, { useContext, useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './ImageSilder.css';
import styled from "styled-components";
import { Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { httpsCallable } from "firebase/functions";
import { functions } from "../../firebase";
import axios from "axios";
import AppContext from "Contexts/AppContext";
import UserContext from "Contexts/User";

export const SampleNextArrow = (props: any) => {
  const { onClick } = props;
  return (
    <div className="custom-arrow next-arrow" onClick={onClick}>    
      {">"}
    </div>
  );
};

export const SamplePrevArrow = (props: any) => {
  const { onClick } = props;
  return (
    <div className="custom-arrow prev-arrow" onClick={onClick}>      
      {"<"}
    </div>
  );
};


const SliderDiv = styled.div`
  text-align: center;
  width: 100%;
  border: 2px solid #FFD700;
  border-radius: 14px;
  box-shadow: 0 2px 10px rgba(255, 215, 0, 0.10), 0 1px 4px rgba(0,0,0,0.10);
  background: rgba(30, 30, 30, 0.97);
  padding: 10px 7px;
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Title = styled.span`
  color: #FFD700;
  // font-size:${window.screen.width > 767 ?"14px":"12px"};
  // font-weight:600;  
`;

const ImageWrapper = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 250px; /* ✅ adjusted height for better proportions */

  img {
    width: 100%;
    height: 100%;
    object-fit: contain; /* ✅ changed from scale-down to contain for better image display */
    border-radius: 10px;
  }
  cursor: pointer;
  
   @media (max-width: 767px) {
    height: 180px; /* ✅ adjusted mobile height */
  }
`;


const CardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

const SilderText = styled.p`
  color: #fff;
  font-size: ${window.screen.width > 767 ? "15px" :window.screen.width <400? "9px" : "10px"};
  font-weight: 500;
  margin: 8px 0 4px 0;
  line-height: 1.4;
`;

const BuyButton = styled.button`
  background: linear-gradient(90deg, #FFD700 0%, #FFC300 100%);
  color: #222;
  font-weight: bold;
  font-size: 15px;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  padding: 10px 10px;
  margin-top: 18px;
  margin-bottom: 0;
  box-shadow: 0 1px 4px rgba(255, 215, 0, 0.10);
  transition: all 0.16s cubic-bezier(.4,0,.2,1);
  position: relative;
  outline: none;
  letter-spacing: 0.5px;
  width: 100%;
  max-width: 180px;
  &:hover {
    background: linear-gradient(90deg, #FFC300 0%, #FFD700 100%);
    color: #fff;
    box-shadow: 0 4px 12px rgba(255, 215, 0, 0.18);
    transform: translateY(-1px) scale(1.02);
  }
`;


function ImageSlider() {
  const isMobile = window.innerWidth < 768;
  const [show, setShow] = useState(false); 
  const [allProducts, setAllProducts] = useState([]);
  const {buyProduct,setBuyProduct} = useContext(AppContext);
  const { userInfo} = useContext(UserContext); 
  const settings = {
    // dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    nextArrow:<SampleNextArrow />,
    prevArrow:<SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: { 
          infinite: true,
          slidesToShow: 3, 
          slidesToScroll: 1,
          speed: 400
        }
      },
      {
        breakpoint: 600,
        settings: {  
          infinite: true,
          slidesToShow: 2.5, 
          slidesToScroll: 1, 
          initialSlide: 0,
          speed: 350,
          swipeToSlide: true,
          touchThreshold: 10
        }
      },
      {
        breakpoint: 480,
        settings: {  
          infinite: true,
          slidesToShow: 2.5, 
          slidesToScroll: 1,
          initialSlide: 0,
          speed: 300,
          swipeToSlide: true,
          touchThreshold: 5,
          touchMove: true
        }
      }
    ]
  };
  useEffect(()=>{
    axios.get(`${process.env.REACT_APP_V2E}getAllProductsFromDatabase`).then((res:any)=>{
      setAllProducts(res?.data?.data)
    }).catch((err:any)=>{
      console.log(err)
    })    
  },[])
    
  const navigate = useNavigate();    

  function parseNumber(value:string) {
    if (typeof value === 'string') {
      const lower = value.toLowerCase();
      if (lower.endsWith('k')) {
        return parseFloat(lower) * 1000;
      } else if (lower.endsWith('m')) {
        return parseFloat(lower) * 1000000;
      } else if (lower.endsWith('b')) {
        return parseFloat(lower) * 1000000000;
      }
    }
    return Number(value); // fallback for plain numbers like 500
  }

  const formatNumber = (value:number) => {
    if (value >= 1_000_000_000) {
      return (value / 1_000_000_000).toFixed(1).replace(/\.0$/, '') + 'B';
    } else if (value >= 1_000_000) {
      return (value / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M';
    } else if (value >= 1_000) {
      return (value / 1_000).toFixed(1).replace(/\.0$/, '') + 'k';
    } else {
      return value.toString();
    }
  }  
  console.log(allProducts,"allProducts")
  return (
    <div className="" style={{ width: window.innerWidth > 767 ? "70%" : "97%", margin: "auto" }}>
      <div className="slider-container"
      
      >
        <Slider {...settings}>
          {allProducts.sort((a:any, b:any) => a.id - b.id).map((item:any, index) => (
            <SliderDiv key={index}             
            onClick={()=>{
              if(userInfo?.uid == undefined) {
                localStorage.setItem("redirectUrl",window.location.pathname)
                navigate("/onekey")
                return null
              }
              if(item?.rarity){
                let price = parseNumber(item?.priceUsd)
                let payvalue = [price,"PRODUCT_PURCHASE",0, 0,item?.id]
                // let payvalue = [0.000001,"PRODUCT_PURCHASE",0, 0,index+1]
                let PayValuestring = JSON.stringify(payvalue)
                localStorage.setItem("PayAmount", PayValuestring);
                navigate(`/buywincard`)
                setBuyProduct(item)
              }
            }}
            >
              <CardWrapper>
                <ImageWrapper>
                  <img src={item?.image_link} alt="" style={{ marginBottom: '14px' }} />
                </ImageWrapper>
                <SilderText style={{ marginTop: '10px', marginBottom: '2px' }}>
                  {["Mystery Box", "Gold Mystery Box"].includes(item?.name)?"":"Rarity"} <Title>{item?.rarity}</Title>
                </SilderText>
                <SilderText style={{ margin: '2px 0' }}>Pay ${(item.priceUsd).toLocaleString()}</SilderText>
                <p className="my-2" style={{ fontSize: `${window.screen.width > 767 ? "15px" :window.screen.width <400? "9px" : "10px"}`, color: "#FFD700", margin: '6px 0 0 0' }}>
                  <span className="text-white">Get {["Mystery Box", "Gold Mystery Box"].includes(item?.name) ? "up to" : ""} </span> <span className="VoinValue">{formatNumber(item?.vCoin)} Vcoin</span>
                </p>
                {
                  item?.remaining > 0 ? <BuyButton>Buy Now</BuyButton>:
                  <div style={{ 
                    display: 'flex', 
                    justifyContent: 'center', 
                    marginTop: '16px',
                    // padding: '20px'
                  }}>
                    <button 
                      style={{
                        backgroundColor: 'af56fe',
                        color: 'black',
                        border: 'none',
                        padding: '12px 20px',
                        borderRadius: '8px',
                        fontSize: '13px',
                        fontWeight: 'bold',
                        cursor: 'not-allowed',
                        opacity: 0.7
                      }}
                      disabled
                    >
                      out of stock
                    </button>
                  </div>
                  }
              </CardWrapper>
            </SliderDiv>
          ))}
        </Slider>        
      </div>      
    </div>
  );
}

export default ImageSlider;
